import { Sell } from "@mui/icons-material";
import dayjs from '../../utils/dayjs-setup';
import { Box, Button, Chip, GridLegacy as Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import { useState, useEffect, useContext, useMemo, useRef } from "react";
import { AutoCompleteInputWithLabel } from "../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { AxiosInstance, FormActions, FormatPrice } from "../../utils/constants";
import * as yup from "yup";
import {  ModalSubastas, } from "../../components/form/ModalForm";
import { isSubastaLiveEnabled } from "../../features/subasta-inversa-live";
import { useAuctionSocket } from "../../features/subasta-inversa-live/hooks/useAuctionSocket";
import { useNavigate } from "react-router-dom";
import { FilterForm } from "../../components/form/filter-form";
import CustomContextMenu from "../../components/context-menu";
import { ModalFichaTecnicaView } from "../../components/ficha-tecnica-view";
import { CustomDialog } from "../../components/modals/custom-dialog";
import { App_sesion_token_key } from "../../utils/constants";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';





const createEmptySubasta = () => {
  const fecha_inicio = dayjs();
  return {
    puntos_entrega: [],
    fecha_inicio,
    fecha_fin: fecha_inicio.add(1, 'day'),
    tyc: "",
    producto: null,
    valor_apertura: 0,
    cantidad_requerida: 0
  };
}


const schemaFilter = yup.object({
}).required();

const InitialFilterSearch = {
  rows_per_page: 20,
  page_number: 0,
  filter_search: "",
  producto: null,
  proveedor: null
};

export const MisSubastas = () => {
  const navigate = useNavigate();
  const [dataSetProdctos, setDataSetProductos] = useState([]);
  const [filterSearchPagination, setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows, setTotalRows] = useState(0);
  const { dispatch, store: { profile } } = useContext(AppContext);
  const [isVisibleModalDetalle, setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado, setProductoSeleccionado] = useState(createEmptySubasta());
  const [tipoAction, setTipoAction] = useState(FormActions.AGREGAR);
  const [productosOptions, setProductosOptions] = useState([]);
  const [proveedorOptions, setProveedorOptions] = useState([]);
  const [modalFichaTecnicaConfig,setModalFichaTecnicaConfig] = useState({
     cod_producto:0,
     isOpened:false
  });
  const [internalDialog,setInternalDialog] = useState({});

  const liveEnabled = isSubastaLiveEnabled();
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem(App_sesion_token_key) : null;
  const reloadTimerRef = useRef(null);

  const applyLivePrice = (cod, vigente) => {
    const vigenteNum = Number(vigente);
    if (!Number.isFinite(vigenteNum)) return;
    setDataSetProductos((prev) => prev.map((item) => {
      if (String(item.cod) !== String(cod)) return item;
      const precios = Array.isArray(item.precios_ofertados) ? [...item.precios_ofertados] : [];
      if (precios.length === 0) precios.push({ valor: vigenteNum });
      else precios[0] = { ...precios[0], valor: vigenteNum };
      return { ...item, precios_ofertados: precios };
    }));
  };

  const scheduleReload = () => {
    if (reloadTimerRef.current) return;
    reloadTimerRef.current = setTimeout(() => {
      reloadTimerRef.current = null;
      loadItems(false, true);
    }, 400);
  };

  const onSocketEvent = (eventName, payload) => {
    const cod = payload?.cod_subasta;
    if (cod == null) return;
    if (eventName === 'auction.price_updated' || eventName === 'auction.bid_created') {
      applyLivePrice(cod, payload.precio_vigente);
      return;
    }
    if (eventName === 'auction.closed' || eventName === 'auction.awarded' || eventName === 'auction.expired') {
      scheduleReload();
    }
  };

  const extraRooms = useMemo(
    () => dataSetProdctos.map((d) => `subasta:${d.cod}`).filter(Boolean),
    [dataSetProdctos]
  );

  const { socketDown } = useAuctionSocket({
    token,
    extraRooms,
    enabled: liveEnabled && !!token,
    onEvent: onSocketEvent,
  });





  useEffect(() => {


    loadInitData();

  }, []);


  useEffect(() => {

    loadItems(filterSearchPagination.filter_search ? false : true);
  }, [filterSearchPagination]);


  const loadInitData = async () => {
    dispatch({
      type: ActionTypes.setLoadingPage,
      data: true
    });
    await loadItems(false);



    dispatch({
      type: ActionTypes.setLoadingPage,
      data: false
    });
  }

  const loadItems = async (loading = true, silent = false) => {
    if (!silent) {
      setDataSetProductos([]);
    }
    if (loading) {
      dispatch({
        type: ActionTypes.setLoadingPage,
        data: true
      });
    }

    let { data: { value } } = await AxiosInstance.post("subastas/listar-maestro-subasta", {
      ...filterSearchPagination,
      page_number: filterSearchPagination.page_number + 1
    });
    setDataSetProductos([...value.data]);

    setTotalRows(value.total);
    dispatch({
      type: ActionTypes.setLoadingPage,
      data: false
    });

  }

  useEffect(() => {
    if (!liveEnabled) return undefined;
    const intervalMs = socketDown ? 5000 : 30000;
    const interval = setInterval(() => { loadItems(false, true); }, intervalMs);
    return () => clearInterval(interval);
  }, [socketDown, liveEnabled, filterSearchPagination]);

  useEffect(() => {
    return () => {
      if (reloadTimerRef.current) {
        clearTimeout(reloadTimerRef.current);
        reloadTimerRef.current = null;
      }
    };
  }, []);


  const handleChangePage = (event, newPage) => {

    setFilterSearchPagination({ ...filterSearchPagination, page_number: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    setFilterSearchPagination({ ...filterSearchPagination, rows_per_page: parseInt(event.target.value, 10) });

  };

  const onShowDetailProduct = (cod_prod) => {
    setIsVisibleModalDetalle(true);
    setTipoAction(FormActions.MODIFICAR);
    let product = dataSetProdctos.find(prod => prod.cod === cod_prod);
    setProductoSeleccionado({
      ...product,
      fecha_inicio: dayjs(product.fecha_inicio),
      fecha_fin: dayjs(product.fecha_fin),
      producto: {
        label: `${product.producto_cod_erp}-${product.producto_descripcion}`,
        value: product.cod
      },
      puntos_entrega: product.puntos_entrega.map(item => ({
        centro_operacion: {
          label: `${item.centro_op_cod_erp}-${item.centro_op_descripcion}`,
          value: item.cod_centro_op
        },
        cantidad: Number(item.cant_entregar)
      }))
    });

  }
  const onHideDetailProduct = () => {
    setIsVisibleModalDetalle(false);
     setTipoAction(FormActions.MODIFICAR);
    setProductoSeleccionado(createEmptySubasta());
  }

  const onOpenModalItem = (edit = false) => {
    if (!edit) {
      setProductoSeleccionado(createEmptySubasta());
      setTipoAction(FormActions.AGREGAR);
    }
    setIsVisibleModalDetalle(true);
  }

  const onShowFichaTecnicaProducto = (cod_producto) => {
           setTipoAction(FormActions.MODIFICAR);
          setModalFichaTecnicaConfig({...modalFichaTecnicaConfig,cod_producto,isOpened:true})
  }

  const onSearchProducto = async (value_search) => {

    if (value_search && value_search.length > 3) {
      try {

        const { data: { value } } = await AxiosInstance.post("maestros/get-producto-filter", {
          search_query: value_search
        });
        return value


      } catch (e) {
        return [];
      }

    }



  }

  const searcProductoAsociado = async (event, newInputValue) => {
    try {
      let res = await onSearchProducto(newInputValue);
      console.log({ res });
      setProductosOptions(res);
    } catch (e) {

    }
  }

  const cerrarAnticipadamenteLaSubasta = (subasta_cod)=>{
    const cod = typeof subasta_cod === 'object' && subasta_cod !== null
      ? (subasta_cod.cod ?? subasta_cod.cod_subasta)
      : subasta_cod;
    if (!cod) {
      setInternalDialog({
        maxWidth:"sm",
        isOpened:true,
        title:'La subasta no pudo ser cerrada',
        content:'No se recibió un código de subasta válido.',
        actions:[{
          buttomProps:{
            variant:"contained",
            size:"small",
            color:"primary",
            onClick:()=>setInternalDialog({})
          },
          title:"OK"
        }]
      });
      return;
    }
     dispatch({
        type: ActionTypes.setLoadingPage,
        data: true
      });
    AxiosInstance.post("subastas/cerrar-subasta", {
          cod_subasta: Number(cod)
    }).then( ({data})=>{
       

        if ( data.status ){
           loadItems(false);
        }else{

          setInternalDialog({
            maxWidth:"sm",
            isOpened:true,
            title:'La subasta no pudo ser cerrada',
            content:data.msg || 'El servidor rechazó el cierre.',
            actions:[
              {
                buttomProps:{
                variant:"contained",
                size:"small",
                color:"primary",
                onClick:()=>{
                  setInternalDialog({});
                }
              },
              title:"OK"
            }
            ]
         });

        }


    }).catch(e=>{
      setInternalDialog({
        maxWidth:"sm",
        isOpened:true,
        title:'La subasta no pudo ser cerrada',
        content: e?.response?.data?.msg || 'El servidor no pudo cerrar la subasta.',
        actions:[{
          buttomProps:{
            variant:"contained",
            size:"small",
            color:"primary",
            onClick:()=>setInternalDialog({})
          },
          title:"OK"
        }]
      });
    }).finally( ()=>{
       dispatch({
        type: ActionTypes.setLoadingPage,
        data: false
      });

    } )
  }

  const setFilterAply = (filtros) => {
    console.log({ filtros });
    setFilterSearchPagination({
      ...filterSearchPagination,
      page_number: 0,
      producto: filtros.producto?.value,
      proveedor: filtros.proveedor?.value
    });

  }
  const onCloseSubasta = (subastaCod)=>{


          setInternalDialog({
          maxWidth:"sm",
          isOpened:true,
          title:'Confirmar accion',
          content:`Recuerde que al cerrar la subasta se tomara  el precio mas bajo y se publicara como una cotizacion, para su posterior uso`,
          actions:[
            {
              buttomProps:{
               variant:"contained",
               size:"small",
               color:"error",
               onClick:()=>{
                setInternalDialog({});
               }
            },
            title:"NO"
          },
            {
              buttomProps:{
               variant:"contained",
               size:"small",
               color:"success",
               onClick:()=>{
                  cerrarAnticipadamenteLaSubasta(subastaCod);
                  setInternalDialog({});
               }
            },
            title:"SI, DAR CIERRE"},
          ]
         });
  }

  const verEscalaPrecios = (subastaData)=>{

          setInternalDialog({
          isOpened:true,
          title:'Escala de precios',
          maxWidth:"sm",
          content:<Box>
              <Stepper   activeStep={1} orientation="vertical">
                    {
                      subastaData.precios_ofertados.slice(0,5).map((item,index)=><Step  key={index}  >
                        <StepLabel  
                         optional={
                           <table border="1" style={{borderCollapse:"collapse"}} >
                            <tbody>
                              <tr>
                                <th style={{fontSize:'10px'}} >USUARIO</th>
                                <td style={{fontSize:'10px'}} >{item.usuario}</td>
                              </tr>
                              <tr>
                                <th style={{fontSize:'10px'}} >PROVEEDOR</th>
                                <td style={{fontSize:'10px'}} >{item.proveedor}</td>
                              </tr>
                              <tr>
                                <th style={{fontSize:'10px'}} >TELEFONO</th>
                                <td style={{fontSize:'10px'}} >{item.celular}</td>
                              </tr>
                            </tbody>
                           </table>
                          }
                        >
                            $ {FormatPrice(item.valor,2)}
                        </StepLabel>
                      </Step>
                      )
                    }
              </Stepper>
          </Box>,
          actions:[
            {
              buttomProps:{
               variant:"contained",
               size:"small",
               color:"error",
               onClick:()=>{
                setInternalDialog({});
               }
            },
            title:"NO"
          }
          ]
         });
  }

  const colorStatusSubastas = {
    "PUBLICADA":"success",
    "CREADA":"default",
    "CERRADA":"error"
  }

  const columnsTable = [
    {

      key: "cod",
      keyValue: "cod",
      label: "ID",
      headerRender: (props) => props.label,
      bodyRender: (props) => props.value,
      typeRow: "string",
      sort: false,
      sortFunction: () => { },
      sortStatus: "",

    },
    {
      key: "producto",
      keyValue: "producto",
      label: "Producto",
      headerRender: (props) => props.label,
      bodyRender: ({ info }) => `${info.producto_cod_erp}-${info.producto_descripcion}`,
      typeRow: "string",
      sort: false,
      sortFunction: () => { },
      sortStatus: "",

    },
    {

      key: "fecha_creacion",
      keyValue: "fecha_creacion",
      label: "F . creacion",
      headerRender: (props) => props.label,
      bodyRender: ({ info }) => `${dayjs(info.fecha_creacion).format("YYYY-MM-DD")}`,
      typeRow: "string",
      sort: false,
      sortFunction: () => { },
      sortStatus: "",

    },
    {

      key: "vigencia",
      keyValue: "vigencia",
      label: "Vigencia",
      headerRender: (props) => props.label,
      bodyRender: ({ info }) =><label><b>Min:</b> {info.fecha_inicio}<br/><b>Max:</b> {info.fecha_fin} </label>,
      typeRow: "string",
      sort: false,
      sortFunction: () => { },
      sortStatus: "",

    },
    {

      key: "cantidad_requerida",
      keyValue: "cantidad_requerida",
      label: "Cantidad requerida",
      headerRender: (props) => props.label,
      bodyRender: ({ value, info }) => `${FormatPrice(value,2)}`,
      typeRow: "string",
      sort: false,
      sortFunction: () => { },
      sortStatus: "",

    },
    {

      key: "puntos_entrega",
      keyValue: "puntos_entrega",
      label: "P. de entrega",
      headerRender: (props) => props.label,
      bodyRender: ({ value, info }) => `${value.length}`,
      typeRow: "string",
      sort: false,
      sortFunction: () => { },
      sortStatus: "",

    },
     {

      key: "valor_apertura",
      keyValue: "valor_apertura",
      label: "Valor de apertura",
      headerRender: (props) => props.label,
      bodyRender: ({ value, info }) => `$ ${FormatPrice(value,2)}`,
      typeRow: "string",
      sort: false,
      sortFunction: () => { },
      sortStatus: "",

    },
         {

      key: "precio_actual",
      keyValue: "precio_actual",
      label: "Valor subasta",
      headerRender: (props) => props.label,
      bodyRender: ({ value, info }) => `$ ${FormatPrice(info.precios_ofertados[0].valor,2)}`,
      typeRow: "string",
      sort: false,
      sortFunction: () => { },
      sortStatus: "",

    },
    {

      key: "precios_ofertados",
      keyValue: "precios_ofertados",
      label: "N° Ofertas",
      headerRender: (props) => props.label,
      bodyRender: ({ value, info }) => <Chip size="small" color={value.length -1 > 0?"success":"error"} label={`${value.length -1 }`} />  ,
      typeRow: "string",
      sort: false,
      sortFunction: () => { },
      sortStatus: "",
    },
    {

      key: "ind_estado",
      keyValue: "ind_estado",
      label: "Estado",
      headerRender: (props) => props.label,
      bodyRender: ({ value, info }) => <Chip size="small"  label={`${value}`} color={colorStatusSubastas[value]} />,
      typeRow: "string",
      sort: false,
      sortFunction: () => { },
      sortStatus: "",

    },

    {
      key: "acciones",
      keyValue: "cod",
      label: "acciones",
      headerRender: (props) => props.label,
      bodyRender: ({ value,info }) => <>
        <CustomContextMenu
          title_basic="Acciones"
          menuItems={[
            {
              label: "Ver datos",
              onClick: () => onShowDetailProduct(value),
              disabled: false

            },
            {
              label: "ver escala de precios",
              onClick: () => verEscalaPrecios(info),
              disabled: false
            },
            {
              label: "ver ficha tecnica",
              onClick: () => onShowFichaTecnicaProducto(info.producto_cod),
              disabled: false
            },
            ...(isSubastaLiveEnabled() ? [{
              label: "Abrir sala (en vivo)",
              onClick: () => navigate(`/plataforma/subastas/sala/${info.cod}`),
              disabled: false
            }] : []),
            {
              label: "Cerrar subasta",
              onClick: () => onCloseSubasta(info.cod),
              disabled: false
            },

          ]}
        />
      </>,
      typeRow: "number",
      sort: false,
      sortFunction: () => { },
      sortStatus: "",
    },
  ];

  const InputFilters = [
    {
      grid: {
        xs: 4,
        md: 4,
        sm: 4
      },
      InputComponent: AutoCompleteInputWithLabel,
      keyValue: "producto",
      InputComponentProps: {
        label: "Producto",
        fullWidth: true,
        isLoading: false,
        multiple: false,
        size: 'small',
        /*     PopperComponent:(props)=><div hidden={!props.open} >
             
               {props.children}
            </div>, */
        onInputChange: searcProductoAsociado,
        options: productosOptions || [],
        noOptionsText: "Lista vacia",
        getOptionLabel: (option) => option.label,
        isOptionEqualToValue: (option, value) => option.value === value.value,
        filterOptions: (x) => x,
      }
    }

  ];

  return (<>
   <CustomDialog
   {...internalDialog}
    />
    {
      isVisibleModalDetalle &&
      <ModalSubastas
        tipoAction={tipoAction}
        opened={isVisibleModalDetalle}
        onCloseModal={onHideDetailProduct}
        subasta_info={productoSeleccionado}
        onLoadData={loadItems}
      />
    }
    {
      modalFichaTecnicaConfig.isOpened && 
      <ModalFichaTecnicaView 
      onClose={()=>setModalFichaTecnicaConfig({...modalFichaTecnicaConfig,isOpened:false})}
      cod_producto={modalFichaTecnicaConfig.cod_producto} 
      is_opened={modalFichaTecnicaConfig.isOpened} />
    }

    <Grid container spacing={2} >
      <Grid item sm={12} xs={12} md={4} >

        <FilterForm
          buttomDist={
            {
              sx: 3,
              md: 3
            }
          }
          nameFilter={"Buscar subasta por"}
          inputsFilter={InputFilters}
          schemaValidator={schemaFilter}
          initialValuesFilter={
            {
              producto: InitialFilterSearch?.producto,
              proveedor: InitialFilterSearch?.fecha,


            }
          }
          onApplyFilter={setFilterAply}
        />

      </Grid>
      <Grid item sm={12} xs={12} md={12} >
        <Button variant="contained" color="primary" onClick={e => onOpenModalItem(false)} >Nueva subasta</Button>
      </Grid>
      <Grid item sm={12} xs={12} md={12} >

        <TableContainer component={Paper} >
          <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>

              {dataSetProdctos.map(prod =>
                <TableRow key={prod.cod}  >

                  {
                    columnsTable.map(Col =>
                      <TableCell  >
                        {<Col.bodyRender key={prod.key} value={prod[Col.keyValue]} info={prod} />}
                      </TableCell>)
                  }

                </TableRow>
              )}

            </TableBody>

          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

      </Grid>
    </Grid>
  </>)

}